import clsx from "clsx";
import styles from "./label.module.css";

type Props = {
  isDark?: boolean;
  label: {
    labelType: string;
    value: string;
  };
  className?: string;
};
const Label = ({ label, isDark, className = styles.__regular }: Props) => {
  return (
    <span className={clsx(styles.label, className, isDark && styles.dark)}>
      {label.value}
    </span>
  );
};

export default Label;
